export enum FilterType {
  Keyword = 'KEYWORD',
  Popular_Products = 'POPULAR_PRODUCTS',
  CATEGORY = 'CATEGORY',
  MANUFACTURER = 'MANUFACTURER',
  PRODUCT_FAMILY = 'PRODUCT_FAMILY',
  CAPACITY = 'CAPACITY',
}
